import React, { Component } from "react";
import { Col, Label, Input, FormGroup } from "reactstrap";
import _ from 'lodash';
import { IconeInformacao } from './Icones';

export default class FormInputSimples extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alerta : this.props.alerta
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.alerta !== this.props.alerta) {
      this.setState({
        alerta: this.props.alerta
      });
    }
  }

  handleChange = event => {
    this.props.onChange(event, event);
  };

  handlePress = (event) => {
    if(event.key === 'Enter' && this.props.onEnter){
        this.props.onEnter()
    }
  }
  
  handleBlur = event => {
    if (event) 
    {
         // Limite minimo
        if (event.target.value.length < this.props.limiteMinimo) 
        {
          this.setState({
            alerta: `Este campo deve conter no minímo ${this.props.limiteMinimo} caracteres`
          });
        }
        else 
        {
          this.setState({
            alerta: ""
          });
        }

        //Campos obrigatório
        if (this.props.obrigatorio && event && event.target.value.length <= 0) 
        {
          this.setState({
            alerta: this.props.alerta ? this.props.alerta : `Campo obrigatório`
          });
        }
        else 
        {
          this.setState({
            alerta: ""
          });
        }
    }
      
    if (this.props.onBlur) this.props.onBlur(event);
  };

    render() {
        return(
            <Col className={this.props.className ? this.props.className+" form-input-simples" : "form-input-simples"}
                xs={this.props.xs || 'auto'}
                sm={this.props.sm || 'auto'}
                md={this.props.md || 'auto'}
                lg={this.props.lg || 'auto'}
                xl={this.props.xl || 'auto'}
              >
                <div className="w-100">
                    { this.props.titulo && <Label className={this.props.bloqueado ? "label-disabled":""}>{ this.props.titulo } { (this.props.obrigatorio || this.props.showRequiredLabel) ? <span className="label-danger">*</span> : "" } </Label> }
                    <Input  className={this.props.inputClassName ? this.props.inputClassName : ""}
                            defaultValue={ this.props.dado }
                            style={this.props.style}
                            disabled = {this.props.bloqueado ? "disabled" : ""}
                            onKeyPress={this.handlePress}
                            type={ this.props.type ? this.props.type : "text" }
                            placeholder={this.props.placeholder ? this.props.placeholder : ""}
                            min={ this.props.min ? this.props.min : 0 } max={ this.props.max ? this.props.max : 999999 }
                            maxLength={this.props.limiteMaximo ? this.props.limiteMaximo : ""}
                            minLength={this.props.limiteMinimo ? this.props.limiteMinimo : ""}
                            onChange={ this.handleChange }
                            onBlur={ this.handleBlur }      
                            hidden={this.props.hidden}
                            value={this.props.value}
                      />
                </div>
                { (this.state.alerta && this.state.alerta.length>0) && <Label className="label-danger">{ this.state.alerta }</Label> }
                <div className="d-flex align-items-center">
                    {this.props.iconeInfo && <div><IconeInformacao className="pr-1" /></div>}
                    {this.props.extraInfo ? <Label className={`mb-0 ${this.props.extraInfoSmaller ? "label-informacoes" : ""}`}>{this.props.extraInfo}</Label> : ""}
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInputSimples.js